


















































































































import ProgressBar from '@/components/molecules/ProgressBar.vue'
import { log } from '@/log'
import { Payment as ApiPayment } from '@/models/api/payment/payment'
import { CartItem, CartItemList } from '@/models/cart/cart-item'
import { iosCustomUrlSchemes, navigateToHlAppDeeplink } from '@/models/hl-app/custom-url-scheme'
import { AfterPurchaseProcessStatus } from '@/models/purhase/after-purchase-process-status'
import { convertToApplyBundleDiscountParamter } from '@/services/api/bundle-discount'
import PaymentService from '@/services/api/payment'
import { getCreditcardPaymentProvierServiceConfig } from '@/services/payment'
import CreateSelectOptionList from '@/services/payment/create-select-option-list'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import AppId from '@/util/appid'
import { allRight } from '@/util/either-list'
import { atoneErrorMessages, parseAtoneErrorCodeAndMessage } from '@spa/components/pages/order/model/payment/atone-error'
import { AtoneScriptLoader } from '@spa/components/pages/order/model/payment/payment-script-loader'
import {
  createPurchaseExecutionProcessFunctions,
  PurchasePreparationState,
} from '@spa/components/pages/order/model/purchase-execution/execute-purchase'
import { AtoneProcessingState, CheckoutProcessState } from '@spa/components/pages/order/order/models/checkout-process-state'
import { CheckoutStore } from '@spa/components/pages/order/order/models/checkout-store'
import { createPurchaseErrorMessage } from '@spa/components/pages/order/order/purchase-error/purchase-error-message'
import { convertFromOrderPurchaseResult, createRedirectHtmlRenderer } from '@spa/components/pages/order/order/redirect-html-renderer'
import { toScope } from '@spa/components/pages/order/scope-transpiler'
import FullscreenNotificationLayout from '@spa/hl-app/components/fullscreen-notification/FullscreenNotificationLayout.vue'
import { parseRequestData, PaymentParam } from '@spa/hl-app/components/order/models/parse-request-data'
import { PluginMixin } from '@spa/mixins/plugin'
import { PurchaseEstimate, PurchaseService } from '@spa/services/api/purchase'
import {
  atoneAuthenticatedCallbackFactory,
  atoneCancelledCallbackFactory,
  atoneErrorCallbackFactory,
  atoneFailedCallbackFactory,
  atoneSucceededCallbackFactory,
  configAtone,
  convertCartItems as convertCartItemsForAtone,
  makeAtonePayment,
} from '@spa/services/atone'
import {
  Order,
  OrderPurchaseResult,
  OrderService,
  OrderSource,
  timeoutErrorExistsInPurchaseResult,
} from '@spa/services/order'
import { CreditcardModel } from '@spa/store/modules/creditcard/types'
import { Delivery, Payment } from '@spa/store/modules/orderConfirm/types'
import { User } from '@spa/store/modules/user/types'
import { chain, Either, left, right } from 'fp-ts/lib/Either'
import { fromNullable, none, Option, some } from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/pipeable'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

type PageStatus = PageStatusProcessing
  | PageStatusFailed
  | PageStatusNotice

interface PageStatusProcessing {
  status: 'processing'
  view: {
    title: string
  }
}
interface PageStatusFailed {
  status: 'failed'
  view: {
    messages: string[]
  }
}
interface PageStatusNotice {
  status: 'notice'
  view: {
    title: string
    // FontAwesomeをそのまま採用
    icon: 'fa-ban' | 'fa-exclamation-triangle' | 'fa-circle-info'
    messages: string[]
    button: {
      label: string
      onClick: () => void
    }
  }
}

interface ProgressView {
  percent: number
  message: string
}
const progressSteps = {
  'start-cart-loading': {
    percent: 10,
    message: '商品情報を確認しています',
  },
  'start-payment-initializing': {
    percent: 40,
    message: 'お支払い情報を確認しています',
  },
  'start-estimating': {
    percent: 70,
    message: 'ご注文内容を確認しています',
  },
  'start-credit-card-process': {
    percent: 85,
    message: 'クレジットカード情報を確認しています',
  },
  'start-atone-process': {
    percent: 85,
    message: '決済サービスと情報を連携しています',
  },
  'start-purchasing': {
    percent: 95,
    message: 'ご注文を確定しています',
  },
} as const
type ProcessingStepName = keyof typeof progressSteps

class ErrorWithDisplayMessages extends Error {
  static fromError(original: Error, displayMessages: string[]): ErrorWithDisplayMessages {
    const { name, message, stack } = original

    return new ErrorWithDisplayMessages(name, message, stack, displayMessages)
  }
  static fromString(message: string, displayMessages: string[]): ErrorWithDisplayMessages {
    return new ErrorWithDisplayMessages('AnonymousError', message, undefined, displayMessages)
  }
  private constructor(
    name: string,
    message: string,
    stack: string | undefined,
    public readonly displayMessages: string[]
  ) {
    super(message)
    this.name = name
    if (stack) {
      this.stack = `${this.stack}\nCaused by:\n${stack}`
    }
  }
}

@Component({
  components: {
    FullscreenNotificationLayout,
    ProgressBar,
  },
})
export default class PurchaseExecution extends Mixins<PluginMixin>(PluginMixin) {
  status: PageStatus = {
    status: 'processing',
    view: {
      title: 'ご注文内容の確認中です',
    },
  }
  progressView: ProgressView = {
    percent: 0,
    message: '',
  }
  errorMessages: string[] = []
  cancelMessages: string[] = []

  readonly scope = toScope('brand.hl2') // 固定
  readonly appId = AppId.getByBrandName('hl2') // 固定
  readonly orderService = OrderService.create({
    appId: this.appId,
    orderSource: OrderSource.valueOf('hlapp'),
  })
  readonly purchaseService = new PurchaseService(this.appId)
  readonly paymentService = new PaymentService()
  readonly cardPaymentProvider = getCreditcardPaymentProvierServiceConfig().forPurchase

  readonly atoneScriptLoader: AtoneScriptLoader = new AtoneScriptLoader()
  atoneCheckoutProcessState: CheckoutProcessState<AtoneProcessingState> = CheckoutProcessState.forAtone()

  onSubmit: (() => Promise<void>) | null = null

  get defaultErrorMessage(): string {
    return 'エラーが発生しました。'
  }

  backToAppCartView() {
    navigateToHlAppDeeplink(iosCustomUrlSchemes.cart)
  }

  closePage() {
    navigateToHlAppDeeplink(iosCustomUrlSchemes.close)
  }

  goToMypage() {
    navigateToHlAppDeeplink(iosCustomUrlSchemes.mypage)
  }

  async created() {
    try {
      // Leftが返ってきたときにErrorWithDisplayMessagesに変換してthrowする
      const hookError = (displayMessages: string[]) =>
        (error: Error) => {
          throw ErrorWithDisplayMessages.fromError(error, displayMessages)
        }

      const rawData = this.$route.query
      const data = parseRequestData(rawData).mapLeft(
        hookError([this.defaultErrorMessage])
      ).value
      log.debug({ data })

      this.updateProgressView('start-cart-loading')
      const cartList = (await this.loadCart(data.cartIds)).mapLeft(
        hookError([this.defaultErrorMessage])
      ).value
      log.debug({ cartList })

      const orderList = this.orderService.createOrderFromCartItems(
        cartList,
        data.deliveryDate === null ? '未指定' : data.deliveryDate.formattedDate('YYYY年MM月DD日')
      )
      log.debug({ orderList })
      // このページでは注文が分割されないことを暗黙の前提とする
      if (orderList.length !== 1) {
        hookError([this.defaultErrorMessage])(
          new Error(`expected orderList.length is 1, actual is ${orderList.length}`)
        )
      }

      this.updateProgressView('start-payment-initializing')
      const payment = (await this.createPayment(data.cartIds, data.paymentParam, data.appliedPoint)).mapLeft(
        hookError([this.defaultErrorMessage])
      ).value
      log.debug({ payment })

      const delivery: Delivery = {
        deliveryType: 'registered', // vuexの初期値 / vuexでは後から上書きされることはないように見える
        id: data.deliveryContactId, // contact id
        deliveryMethod: data.deliveryMethod, // 配送方法 / e.g. "standard"
        unattendedDelivery: data.unattendedDelivery, // 置き配場所コード / e.g. "10"（置き配以外ではnull）
      }

      this.updateProgressView('start-estimating')
      const purchaseEstimates = (await this.loadEstimates(
        orderList,
        payment,
        delivery,
        data.appliedCouponId
      )).mapLeft(
        hookError([this.defaultErrorMessage])
      ).value
      log.debug({ purchaseEstimates })

      const checkoutStore = this.createCheckoutStore(
        orderList,
        purchaseEstimates,
        data.appliedPoint
      ).mapLeft(
        hookError([this.defaultErrorMessage])
      ).value
      log.debug({ checkoutStore })

      // 実際にログインの処理はApp.vueで実行されている
      const user = (await this.loadUser()).mapLeft(
        hookError(['ログインできませんでした。'])
      ).value
      log.debug({ user })

      const initialPaymentAuthToken = user.payment_auth_token
      const appliedCouponDiscountPrice = fromNullable(checkoutStore.couponDiscountPrice || null)

      const preparationState = new PurchasePreparationState(
        checkoutStore,
        payment,
        user,
        delivery,
        data.deliveryDate,
        data.deliveryTimeSlot,
        data.appliedCouponId,
        appliedCouponDiscountPrice,
        data.appliedPoint,
        null, // サービス手数料 / ホテラバは利用しないので固定を入れている（本来はappsettingsから取得）
        toScope('brand.hl2') // 固定
      )

      const submit = async () => {
        this.status = {
          status: 'processing',
          view: {
            title: 'ご注文の処理中です',
          },
        }
        this.submit(preparationState, payment, initialPaymentAuthToken)
      }

      /**
       * PayPayはWebViewでなくSafariで開かれるため、離脱や中断のハンドリングが難しい
       * 対策として注文実行前にユーザーのアクションを求めることにした
       *
       * @see https://github.com/Everforth/growthpalette-front/pull/8633
       */
      if (payment.payment_type === 'webmoney') {
        this.status = {
          status: 'notice',
          view: {
            icon: 'fa-circle-info',
            title: '注文を確定しPayPayを開きます',
            messages: [],
            button: {
              label: 'PayPayを開く',
              onClick: submit,
            },
          },
        }

        return
      }

      submit()
    } catch (error) {
      if (error instanceof ErrorWithDisplayMessages) {
        await this.onFailed(error)
      } else {
        await this.onFailed(ErrorWithDisplayMessages.fromError(error, [this.defaultErrorMessage]))
      }
    }
  }

  async submit(
    preparationState: PurchasePreparationState,
    payment: Payment,
    initialPaymentAuthToken: string | undefined
  ) {
    try {
      /**
       * FIXME:
       * 支払額がない場合、本来はpaymentTypeIsUserSideでなくても支払い手続きはスキップして良い
       * - client側: NoneProcessで注文を実行する
       * - server側: 支払い方法noneを受け付けて良い注文であるか検証する
       *
       * @see https://github.com/Everforth/growthpalette-front/pull/8479#discussion_r2124680648
       */
      if (preparationState.paymentTypeIsUserSide && preparationState.isFullyDiscountedExceptForPayment) {
        await this.processPurchaseDefault(preparationState)

        return
      }

      switch (payment.payment_type) {
        case 'atone':
          await this.processAtone(preparationState, initialPaymentAuthToken)
          break
        case 'creditcard3d':
          await this.processCreditCard3d(preparationState)
          break
        default:
          await this.processPurchaseDefault(preparationState)
      }
    } catch (error) {
      if (error instanceof ErrorWithDisplayMessages) {
        await this.onFailed(error)
      } else {
        await this.onFailed(ErrorWithDisplayMessages.fromError(error, [this.defaultErrorMessage]))
      }
    }
  }

  /**
   * scopeで取得し、idをキーにピックアップする
   * 指定されたidのカートが存在しなければ失敗
   *
   * - 表示高速化のためホテラバアプリBFFで表示用カートリソースを持っている
   * - Engineのカートと不整合状態にある場合に解消することはアプリBFFの責務ではある
   * - リクエストされたカートのリストの決済を通すことが本ページの責務
   * - したがってリクエストされたカートIDが存在しない場合には失敗とみなし、リクエストされたID以外のカートが存在する場合は無視する
   */
  async loadCart(ids: string[]): Promise<Either<Error, CartItem[]>> {
    // Engineのカートがほしいわけではなく、関連する商品情報をくっつけたFrontのカートが必要
    // そのためにvuexのloadを行っているが、このVueコンポーネントとしてはVuexにロード済みであることに依存したくはない
    // ただし、現状は注文エラー時の表示時にカートがロード済みであることを暗黙的に期待する実装となっていることに注意
    await this.$store.dispatch('cart/loadWithScope', {
      scope: this.scope,
    })

    const wholeCartsOfScope: CartItem[] = this.$store.getters['cart/currentItems']
    const result = ids.reduce(
      (prev: { carts: CartItem[], notFoundIds: string [] }, id) =>
        fromNullable(wholeCartsOfScope.find(cart => cart.id === id)).fold(
          ({
            carts: prev.carts,
            notFoundIds: [...prev.notFoundIds, id],
          }),
          cart => ({
            carts: [...prev.carts, cart],
            notFoundIds: prev.notFoundIds,
          })
        ),
      { carts: [], notFoundIds: [] }
    )

    if (result.notFoundIds.length > 0) {
      return left(new Error(`some cart ids not found: ${result.notFoundIds.join(', ')}`))
    }

    return right(result.carts)
  }

  async loadUser(): Promise<Either<Error, User>> {
    await this.$store.dispatch('user/get')

    const user = this.$store.state.user.user
    if (this.$store.getters['user/hasError'] || !user) {
      return left(new Error('user/get failed'))
    }

    return right(user)
  }

  async createPayment(
    cartIds: string[],
    paymentParam: PaymentParam,
    appliedPoint: number
  ): Promise<Either<Error, Payment>> {
    const availablePaymentList = await this.paymentService.listAllowedPaymentsFor(cartIds, {
      // Amazon Payを利用する場合には必須のようだが、このページはPOSTされることを期待しているので統合が不可能
      // ダミーで空文字を入れている
      confirm_url: '',
    })

    if (availablePaymentList.isLeft()) {
      return left(availablePaymentList.value)
    }

    const apiPayment = availablePaymentList.value.find(p => p.id === paymentParam.paymentMethod)
    if (!apiPayment) {
      return left(new Error(`requested payment method (${paymentParam.paymentMethod}) is not available`))
    }

    /**
     * FIXME:
     * vuexのOrderConfirmのsetPayment系のactionを利用してPaymentオブジェクトを初期化
     * OrderServiceがOrderConfirmのPaymentオブジェクトに依存しているためこのような実装になっているが、積極的にvuexを利用しているわけではない
     * - Order.uveと同じようにOrderConfirm全体を利用しているわけではナック、部分的に必要なオブジェクトを構築するために利用しているだけ
     * - 以下のようにリファクタリングを行いたい
     *   - OrderServiceがOrderConfirmのPaymentに直接依存しないようにする
     *   - OrderServiceが必要とするPaymentに関する知識をvuexから切り出し、vuexを経由せずにPaymentを構築できるようにする
     */
    const setPaymentError = await this.setPayment(paymentParam, apiPayment)
    if (setPaymentError.isSome()) {
      return left(setPaymentError.value)
    }

    // vuexのPaymentオブジェクトに利用ポイント数を追加
    this.$store.dispatch('orderConfirm/applyPoint', {
      applied: appliedPoint,
      // 1stリリースでは、1pt = 1円の決め打ち
      // https://my-color.esa.io/posts/559#%E5%89%B2%E5%BC%95%E9%A1%8D
      discounted: appliedPoint,
    })

    // vuexから取り出して返却
    const payment: Payment | null = this.$store.state.orderConfirm.payment
    if (!payment) {
      return left(new Error(`unexpected state. payment must be defined.`))
    }

    return right(payment)
  }

  async loadEstimates(
    orderList: Order[],
    payment: Payment,
    delivery: Delivery,
    selectedCouponId: string | null
  ): Promise<Either<Error, PurchaseEstimate[]>> {
    const results = await Promise.all(orderList.map((order) => {
      const cartIds = order.cartItems.map(c => c.id)

      /**
       * FIXME:
       * Order.vueに同様の実装あり
       * PurchaseService.getEstimateのparameter builderに切り出したほうが良い
       */
      return this.purchaseService.getEstimate(
        {
          cartIds: cartIds.join(','),
          payment,
          deliveryId: delivery.id,
          deliveryMethod: delivery.deliveryMethod,
          unattendedDelivery: delivery.unattendedDelivery || null,
          ...(order.kind === 'standard' && selectedCouponId) && {
            discount: {
              coupon: { id: selectedCouponId },
            },
          },
        },
        convertToApplyBundleDiscountParamter(order.cartItems)
      )
    }))

    return allRight(results)
      ? right(results.map(r => r.value))
      : left(new Error(`some estimates failed`))
  }

  createCheckoutStore(
    orderList: Order[],
    purchaseEstimates: PurchaseEstimate[],
    discountedByPoint: number
  ): Either<Error, CheckoutStore> {
    return CheckoutStore.create(orderList, purchaseEstimates, discountedByPoint)
  }

  async processCreditCard3d(state: PurchasePreparationState) {
    this.updateProgressView('start-credit-card-process')

    const createProcessResult = await createPurchaseExecutionProcessFunctions.creditCard(
      this.cardPaymentProvider,
      this.orderService,
      state,
      state.checkoutStore.allCheckoutKeys,
      () => { this.updateProgressView('start-purchasing') }
    )
    await createProcessResult.fold<Promise<void>>(
      async (message: string) => {
        await this.onFailed(ErrorWithDisplayMessages.fromString(message, [this.defaultErrorMessage]))
      },
      async (process) => {
        await this.withPurchaseTransaction(process, state)
      }
    )
  }

  async processPurchaseDefault(state: PurchasePreparationState) {
    this.updateProgressView('start-purchasing')
    const createProcessResult = await createPurchaseExecutionProcessFunctions.default(
      this.orderService,
      state,
      state.checkoutStore.allCheckoutKeys
    )
    await createProcessResult.fold<Promise<void>>(
      async (message: string) => {
        await this.onFailed(ErrorWithDisplayMessages.fromString(message, [this.defaultErrorMessage]))
      },
      async (process) => {
        await this.withPurchaseTransaction(process, state)
      }
    )
  }

  async withPurchaseTransaction(
    executePurchase: () => Promise<OrderPurchaseResult[]>,
    state: PurchasePreparationState
  ): Promise<void> {
    const purchaseResult = await executePurchase()
    log.debug({ purchaseResult })
    const afterExecuteResult = await this.afterExecutePurchase(purchaseResult, state)
    afterExecuteResult.fold(
      async () => {
        // エラー時のpage statusの更新はafterExecutePurchase内で行う
      },
      async () => {
        navigateToHlAppDeeplink(iosCustomUrlSchemes.orderComplete)
      }
    )
  }

  async afterExecutePurchase(
    purchaseResult: OrderPurchaseResult[],
    state: PurchasePreparationState
  ): Promise<AfterPurchaseProcessStatus> {
    if (purchaseResult.every(r => !r.success)) {
      if (timeoutErrorExistsInPurchaseResult(purchaseResult)) {
        this.status = {
          status: 'notice',
          view: {
            title: 'ご確認ください',
            icon: 'fa-exclamation-triangle',
            messages: [
              '引き続き購入手続きを処理中です。しばらくお待ち下さい。購入手続きの結果はマイページ＞注文履歴に反映されます。',
            ],
            button: {
              label: 'マイページへ',
              onClick: this.goToMypage,
            },
          },
        }

        return AfterPurchaseProcessStatus.failed()
      }

      // ページ初期化時にカートがvuexにロードされていることに依存していることに注意
      const cartList: CartItem[] = this.$store.getters['cart/currentItems']
      const errorMessages = createPurchaseErrorMessage(
        purchaseResult,
        new CartItemList(cartList)
      )
      await this.onFailed(ErrorWithDisplayMessages.fromString('POST commerce_purchase failed', errorMessages))

      return AfterPurchaseProcessStatus.failed()
    }

    const redirectHtmlRenderer = createRedirectHtmlRenderer(
      state.payment.payment_type,
      purchaseResult.map(r => convertFromOrderPurchaseResult(r))
    )
    if (redirectHtmlRenderer.render()) {
      // リダイレクトが実行された場合にも、実際に遷移が完了するまでは後続の処理が実行されるので、
      // リダイレクトされたというステータスを返し処理を中断する
      return AfterPurchaseProcessStatus.redirected()
    }

    return AfterPurchaseProcessStatus.completed()
  }

  private async onFailed(errorWithDisplayMessages: ErrorWithDisplayMessages) {
    log.error({ error: errorWithDisplayMessages })
    await this.sendError(errorWithDisplayMessages)
    this.setStatusToFailed(errorWithDisplayMessages.displayMessages)
  }

  private async sendError(errorWithDisplayMessages: ErrorWithDisplayMessages) {
    const { name, message, stack, displayMessages } = errorWithDisplayMessages

    const userId = (await this.loadUser()).fold(
      () => '',
      user => user.id
    )
    EventBusForThirdParty.getInstance().publish('publish-developer-reports', [{
      userId,
      level: 'error',
      timestamp: new Date(),
      message: {
        userId,
        error: { name, message, stack },
        displayMessages,
      },
      reportSource: 'hlAppPurchaseExecutionError',
    }])
  }

  private setStatusToFailed(messages: string[]) {
    this.status = {
      status: 'failed',
      view: {
        messages,
      },
    }
  }

  private updateProgressView(step: ProcessingStepName) {
    const value = progressSteps[step]
    if (!value) {
      log.warn(`unexpected step name (${step})`)

      return
    }

    // 進捗が減ると心証が悪いので何もしない
    // percent自体があくまで目安で、コード上厳密に管理されるわけではないため、
    // 実装ミスなどで値を減らすようにこのメソッドが実行されることは十分に考えられる
    if (value.percent < this.progressView.percent) {
      return
    }

    log.debug(`updateProcessingState to ${step}`)

    this.progressView = value
  }

  private async setPayment(paymentParam: PaymentParam, apiPayment: ApiPayment): Promise<Option<Error>> {
    switch (paymentParam.paymentMethod) {
      case 'cash-on-delivery':
        return await this.setPaymentToCashOnDelivery(apiPayment)
      case 'creditcard3d':
        return await this.setPaymentToCreditCard3D(apiPayment, paymentParam.token)
      case 'carrier':
        return await this.setPaymentToCarrier(apiPayment, paymentParam.carrierProvider)
      case 'cvs-number':
        return await this.setPaymentToCvsNumber(apiPayment, paymentParam.cvsType)
      case 'np-postpay':
        return await this.setPaymentToNpPostPay(apiPayment)
      case 'atone':
        return await this.setPaymentToAtone(apiPayment)
      case 'webmoney':
        return await this.setPaymentToPayPay(apiPayment)
      default:
        return some(new Error('unsupported payment type'))
    }
  }

  private async setPaymentToCashOnDelivery(apiPayment: ApiPayment): Promise<Option<Error>> {
    await this.$store.dispatch('orderConfirm/setPaymentToCashOnDelivery', { apiPayment })

    return none
  }

  private async setPaymentToCreditCard3D(apiPayment: ApiPayment, token: string): Promise<Option<Error>> {
    try {
      await Promise.all([
        this.$store.dispatch('creditcard/load'),
        this.cardPaymentProvider.loadScript(),
      ])
    } catch (error) {
      return some(error)
    }

    const creditCardList: CreditcardModel[] = this.$store.state.creditcard.items
    const creditCard = creditCardList.find(c => c.id === token)
    if (!creditCard) {
      return some(new Error(`requested card (${token}) is not found.`))
    }
    const payload = Object.assign(creditCard.clone(), {
      token: creditCard.id,
      payment_type: apiPayment.id,
      apiPayment,
    })
    await this.$store.dispatch('orderConfirm/setPaymentToCreditcard', payload)

    return none
  }

  private async setPaymentToCarrier(apiPayment: ApiPayment, carrierProvider: string): Promise<Option<Error>> {
    const createSelectOptionListResult = CreateSelectOptionList.default().fromPaymentMethod(
      {
        carrier_provider: carrierProvider,
      },
      apiPayment
    )
    if (createSelectOptionListResult.isLeft()) {
      return some(createSelectOptionListResult.value)
    }
    const payload: Payment = {
      payment_type: 'carrier',
      apiPayment,
      selectedOptionList: createSelectOptionListResult.value,
    }
    await this.$store.dispatch('orderConfirm/setPayment', { payment: payload })

    return none
  }

  private async setPaymentToCvsNumber(apiPayment: ApiPayment, cvsType: string): Promise<Option<Error>> {
    const createCvsNumberSelectOptionListResult = CreateSelectOptionList.default().fromPaymentMethod(
      {
        cvs_type: cvsType,
      },
      apiPayment
    )
    if (createCvsNumberSelectOptionListResult.isLeft()) {
      return some(createCvsNumberSelectOptionListResult.value)
    }
    const cvsNumberPayload: Payment = {
      payment_type: 'cvs-number',
      apiPayment,
      selectedOptionList: createCvsNumberSelectOptionListResult.value,
    }
    await this.$store.dispatch('orderConfirm/setPayment', { payment: cvsNumberPayload })

    return none
  }

  private async setPaymentToNpPostPay(apiPayment: ApiPayment): Promise<Option<Error>> {
    await this.$store.dispatch('orderConfirm/setPaymentToNpPostpay', { apiPayment })

    return none
  }

  private async setPaymentToPayPay(apiPayment: ApiPayment): Promise<Option<Error>> {
    const payment: Payment = {
      payment_type: 'webmoney',
      apiPayment,
    }
    await this.$store.dispatch('orderConfirm/setPayment', { payment })

    return none
  }

  private async setPaymentToAtone(apiPayment: ApiPayment): Promise<Option<Error>> {
    try {
      await Promise.all([
        this.$store.dispatch('orderConfirm/setPaymentToAtone', { apiPayment }),
        this.atoneScriptLoader.loadScript(),
      ])
    } catch (error) {
      return some(error)
    }

    return none
  }

  /**
   * TODO: atone関連でメソッドが多いので別ファイルに切り出すなどの整理をしたい
   * @see https://github.com/Everforth/growthpalette-front/pull/8479#discussion_r2124620481
   */
  private async processAtone(preparationState: PurchasePreparationState, initialPaymentAuthToken: string | undefined) {
    this.updateProgressView('start-atone-process')

    if (!Atone) {
      await this.onFailed(
        ErrorWithDisplayMessages.fromString('global object Atone is not defined', [this.defaultErrorMessage])
      )

      return
    }

    const allCheckoutKeys = preparationState.checkoutStore.allCheckoutKeys
    const getCheckoutResult = pipe(
      preparationState.validateCheckoutKeysMustBeSingle(allCheckoutKeys),
      chain(checkoutKey => preparationState.validateCheckoutExistence(checkoutKey))
    )
    if (getCheckoutResult.isLeft()) {
      await this.onFailed(ErrorWithDisplayMessages.fromError(getCheckoutResult.value, [this.defaultErrorMessage]))

      return
    }
    const checkout = getCheckoutResult.value

    const provisionalOrderIdResult = await this.purchaseService.createProvisionalOrderId()
    if (provisionalOrderIdResult.isLeft()) {
      await this.onFailed(
        ErrorWithDisplayMessages.fromError(provisionalOrderIdResult.value, [this.defaultErrorMessage])
      )

      return
    }
    const orderId = provisionalOrderIdResult.value

    await this.$store.dispatch('contact/load')
    const contact = this.$store.getters['contact/get'](preparationState.delivery.id)
    if (!contact) {
      await this.onFailed(ErrorWithDisplayMessages.fromString(
        `contact (${preparationState.delivery.id}) is not fetched`,
        [this.defaultErrorMessage]
      ))

      return
    }

    const atonePaymentItems = convertCartItemsForAtone({
      items: checkout.cartItems,
      shipping: checkout.shippingFee,
      discountAmount: checkout.discountAmount,
    })
    const atonePaymentResult = await makeAtonePayment(
      orderId,
      preparationState.user,
      contact,
      atonePaymentItems
    )
    if (atonePaymentResult.isLeft()) {
      await this.onFailed(ErrorWithDisplayMessages.fromError(atonePaymentResult.value, [this.defaultErrorMessage]))

      return
    }

    configAtone(
      preparationState.user.id,
      {
        preToken: initialPaymentAuthToken || '',
        payment: atonePaymentResult.value,
        authenticated: this.atoneAuthenticatedCallback,
        cancelled: this.atoneCancelledCallback,
        failed: this.atoneFailedCallback,
        succeeded: this.atoneSucceededCallback,
        error: this.atoneErrorCallback,
      }
    )

    const pushStateResult = this.atoneCheckoutProcessState.pushState({
      purchasePreparationState: preparationState,
      checkout,
      orderId,
      paymentAuthToken: fromNullable(initialPaymentAuthToken),
    })
    if (pushStateResult.isLeft()) {
      await this.onFailed(ErrorWithDisplayMessages.fromError(pushStateResult.value, [this.defaultErrorMessage]))

      return
    }

    Atone.start()
  }

  private async atoneAuthenticatedCallback(authenticationToken: string, userNo: string): Promise<void> {
    const userId = this.atoneCheckoutProcessState.readState()
      .map(state => state.purchasePreparationState.user.id)
      .getOrElse('')

    return atoneAuthenticatedCallbackFactory(
      userId,
      { authenticationToken, userNo },
      async (authToken: string) => {
        this.atoneCheckoutProcessState.partialUpdate({
          paymentAuthToken: some(authToken),
        }).mapLeft(async (e) => {
          await this.onFailed(ErrorWithDisplayMessages.fromString(
            `failed to update paymentAuthToken: ${e.message}`,
            [this.defaultErrorMessage]
          ))
        })
      },
      // authTokenのupdateに失敗しても処理は継続する
      async () => { /* nothing */ }
    )
  }

  private atoneCancelledCallback(): Promise<void> {
    const userId = this.atoneCheckoutProcessState.readState()
      .map(state => state.purchasePreparationState.user.id)
      .getOrElse('')
    this.atoneCheckoutProcessState.reset()

    this.status = {
      status: 'notice',
      view: {
        title: 'キャンセルされました',
        icon: 'fa-ban',
        messages: [
          'お支払いが完了していません。',
          '再度お手続きをお願いいたします。',
        ],
        button: {
          label: '閉じる',
          onClick: this.closePage,
        },
      },
    }

    return atoneCancelledCallbackFactory(userId)
  }

  private atoneFailedCallback(response: any): Promise<void>  {
    const userId = this.atoneCheckoutProcessState.readState()
      .map(state => state.purchasePreparationState.user.id)
      .getOrElse('')
    this.atoneCheckoutProcessState.reset()

    return atoneFailedCallbackFactory(
      userId,
      response,
      async () => {
        await this.onFailed(ErrorWithDisplayMessages.fromString(
          `failed atone process: ${JSON.stringify(response)}`,
          [this.defaultErrorMessage]
        ))
      }
    )
  }

  private async atoneSucceededCallback(response: any): Promise<void> {
    this.updateProgressView('start-purchasing')
    const userId = this.atoneCheckoutProcessState.readState()
      .map(state => state.purchasePreparationState.user.id)
      .getOrElse('')

    const actionOnSuccess = async () => {
      const { id } = response

      const popStateResult = this.atoneCheckoutProcessState.popState()
      if (popStateResult.isLeft()) {
        await this.onFailed(ErrorWithDisplayMessages.fromError(popStateResult.value, [this.defaultErrorMessage]))

        return
      }
      const { purchasePreparationState, checkout, orderId, paymentAuthToken } = popStateResult.value
      if (paymentAuthToken.isNone()) {
        await this.onFailed(ErrorWithDisplayMessages.fromString(
          'paymentAuthToken does not exist in atoneCheckoutProcessState',
          [this.defaultErrorMessage]
        ))

        return
      }

      const purchaseExecutionProcess = await createPurchaseExecutionProcessFunctions.atone(
        this.orderService,
        purchasePreparationState,
        checkout,
        orderId,
        id,
        paymentAuthToken.value
      )
      if (purchaseExecutionProcess.isLeft()) {
        await this.onFailed(ErrorWithDisplayMessages.fromString(
          purchaseExecutionProcess.value,
          [this.defaultErrorMessage])
        )

        return
      }

      await this.withPurchaseTransaction(purchaseExecutionProcess.value, purchasePreparationState)
    }

    return atoneSucceededCallbackFactory(userId, response, actionOnSuccess)
  }

  private async atoneErrorCallback(name: string, message: string, errors: any[]) {
    const userId = this.atoneCheckoutProcessState.readState()
      .map(state => state.purchasePreparationState.user.id)
      .getOrElse('')

    atoneErrorCallbackFactory(
      userId,
      { name, message, errors },
      async () => {
        this.atoneCheckoutProcessState.reset()
        const atoneErrors = parseAtoneErrorCodeAndMessage(errors)
        const atoneErrorMessage = atoneErrorMessages(this.defaultErrorMessage, atoneErrors)
        await this.onFailed(ErrorWithDisplayMessages.fromString(`atone error callback: ${name}`, [atoneErrorMessage]))
      }
    )
  }
}
